import { useEffect, useState } from "react";
import api, { formatApiError, formatMoney } from "@/lib/api";
import { toast } from "sonner";
import { Minus, Plus, ShoppingCart, Truck } from "@phosphor-icons/react";

export function BuyNowPanel({ item }) {
  const [qty, setQty] = useState(1);
  const [busy, setBusy] = useState(false);
  const [settings, setSettings] = useState(null);
  const unit = item.show_member_price ? item.member_price : item.msrp_price;

  useEffect(() => { api.get("/shop/settings").then(({ data }) => setSettings(data)).catch(() => {}); }, []);

  const buy = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/shop/checkout", { product_id: item.id, quantity: qty, origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) { toast.error(formatApiError(e)); setBusy(false); }
  };

  return (
    <div className="border-t border-[#262626] pt-4 mt-4 space-y-3" data-testid="buy-now-panel">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center border border-[#262626]" data-testid="buy-now-qty">
          <button type="button" onClick={() => setQty((q) => Math.max(1, q - 1))} className="p-3 text-white hover:text-[#00D4FF]" data-testid="buy-now-qty-minus"><Minus size={12} weight="bold" /></button>
          <span className="w-10 text-center font-mono text-white" data-testid="buy-now-qty-value">{qty}</span>
          <button type="button" onClick={() => setQty((q) => Math.min(99, q + 1))} className="p-3 text-white hover:text-[#00D4FF]" data-testid="buy-now-qty-plus"><Plus size={12} weight="bold" /></button>
        </div>
        <div className="text-right">
          <div className="font-mono text-[10px] text-[#52525B] tracking-widest uppercase">Subtotal</div>
          <div className="font-mono font-bold text-lg text-white" data-testid="buy-now-subtotal">{formatMoney(unit * qty)}</div>
        </div>
      </div>
      <button onClick={buy} disabled={busy} className="btn-primary w-full justify-center" data-testid="buy-now-btn">
        <ShoppingCart size={14} weight="bold" /> {busy ? "Opening secure checkout..." : "Buy Now"}
      </button>
      {settings && (
        <div className="flex items-start gap-2 font-mono text-[10px] text-[#9CA3AF] tracking-wider uppercase" data-testid="buy-now-shipping-note">
          <Truck size={12} weight="bold" className="mt-0.5 text-[#00D4FF]" />
          <span>Flat-rate shipping {formatMoney(settings.flat_shipping_rate)}{settings.pickup_label ? ` · or free ${settings.pickup_label}` : ""} · tax calculated at checkout</span>
        </div>
      )}
    </div>
  );
}
